import { StateCreator } from "zustand";
import { fetchMonthlyPOBOrdersDataType } from "../../../domain/models/daily-pob-report/dailypobreport";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { FetchMonthlyPOBOrdersData } from "../../../domain/useages/daily-pob-report/fetch-monthly-pob-orders-data";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import { RemoteFetchMonthlyPOBOrdersData } from "../../../data/usecases/daily-pob-report/remote-monthly-pob-orders-data";
import Endpoints from "../../../domain/endpoints";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface FetchMonthlyPOBOrdersDataInterface {
  monthlyPOBOrdersData: fetchMonthlyPOBOrdersDataType;
  FetchMonthlyPOBOrdersDataState: FetchState;
  fetchMonthlyPOBOrdersData: Function;
}

const initialStates = {
  monthlyPOBOrdersData: {} as fetchMonthlyPOBOrdersDataType,
  FetchMonthlyPOBOrdersDataState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useFetchMonthlyPOBOrdersData: StateCreator<
  FetchMonthlyPOBOrdersDataInterface
> = (set) => ({
  ...initialStates,
  fetchMonthlyPOBOrdersData: async (
    month: number,
    year: number,
    params: FetchMonthlyPOBOrdersData.Params
  ) => {
   const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
   const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchMonthlyPOBOrdersData = new RemoteFetchMonthlyPOBOrdersData(
      `${BASE_URL}${Endpoints.FETCH_MONTHLY_POB_ORDERS_DATA}`,
      axiosHttpClient
    );

    set(() => ({ FetchMonthlyPOBOrdersDataState: FetchState.LOADING }));
    const result = await remoteFetchMonthlyPOBOrdersData.fetch(
      month,
      year,
      params
    );
    return result;
  },
});
